import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { colorClassForTaskState, statusTextForTask } from "utils/taskStatus";
import styles from "./JobDetailTaskGraphicSquare.module.scss";
import classnames from "classnames";
import moment from "moment";

interface Props {
    task: sage.model.ITask;
}

const JobDetailTaskGraphicSquare: React.FC<Props> = ({ task }) => {
    const currColorClass = React.useMemo(() => {
        return colorClassForTaskState(task.curr_state);
    }, [task.curr_state]);

    const popover = (
        <Popover id={task.id}>
            <Popover.Title>
                <b>Frame {task.frame}</b>
                <br />
                <small>
                    {task.start_x}, {task.start_y} to {task.end_x}, {task.end_y}
                </small>
            </Popover.Title>
            <Popover.Content>
                This task is{" "}
                <span className={`text-${currColorClass}`}>
                    {statusTextForTask(task)}
                </span>
                . It was last updated{" "}
                {moment(new Date(task.updated_at)).fromNow()}.{" "}
                {task.is_probably_stuck &&
                    " This task looks to be stuck. It will restart automatically."}{" "}
                {task.curr_state === "ERROR" &&
                    " This task is errored, it will restart automatically."}
            </Popover.Content>
        </Popover>
    );

    return (
        <>
            <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="top"
                overlay={popover}
            >
                <div
                    className={classnames(
                        styles.square,
                        `bg-${currColorClass}`
                    )}
                ></div>
            </OverlayTrigger>
        </>
    );
};

export default JobDetailTaskGraphicSquare;
